export const BOOKING_CODE_PREFIX_BASE_QUERY_KEY = 'booking-code-prefix';

export const bookingCodePrefixApiQueryKeys = {
  all: () => [BOOKING_CODE_PREFIX_BASE_QUERY_KEY] as const,
};
